import React, { useEffect } from "react";
import { EditOutlined } from "@ant-design/icons";
import { Form, Input, Button, Image } from "antd";
import TextArea from "antd/es/input/TextArea";
import ButtonWrapper from "../../../views/components/reuseComp/ButtonWrapper";
import { Copyright } from "lucide-react";
import UploadImage from "../../components/UploadImage";

interface FooterData {
  about?: string;
  copyright?: string;
  logo?: string
}

const Footer: React.FC<{
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: any;
  footerData?: FooterData;
  loading?: boolean;
}> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  loading,
  footerData,
}) => {
  useEffect(() => {
    if (footerData) {
      form.setFieldsValue({
        footer: {
          about: footerData.about || "",
          copyright: footerData.copyright || "",
          logo: footerData.logo || "",

        },
      });
    } else {
      form.resetFields();
    }
  }, [footerData]);

  return (
    <div>
      {!isEditing ? (
        <>
          <div className="rounded-[20px] overflow-hidden hidden sm:block">
            <table className="min-w-full">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left">Logo</th>
                  <th className="py-3 px-4 text-left">About</th>
                  <th className="py-3 px-4 text-left">Copyright</th>
                  <th className="py-3 px-4 text-right">Action</th>
                </tr>
              </thead>

              <tbody>
                {footerData ? (
                  <tr className="bg-[#F9F9F9] border-b">
                    <td className="py-3 px-4"><Image src={footerData.logo} width={100} height={100} /></td>
                    <td className="py-3 px-4">{footerData.about}</td>
                    <td className="py-3 px-4">{footerData.copyright}</td>

                    <td className="py-3 px-4 text-right">
                      <EditOutlined
                        onClick={() => setIsEditing(true)}
                        className="cursor-pointer text-primary text-[20px]"
                      />
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center py-6">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add Footer Data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="sm:hidden mt-3 space-y-4">
            <div className="bg-[#F9F9F9] border border-gray-200 rounded-lg p-4 shadow-sm space-y-3">

                
              <div>
                <span className="font-semibold text-primary block mb-1">
                  Logo:
                </span>
                <Image src={footerData?.logo || "—"} width={100} height={100}/>
              </div>

              <div>
                <span className="font-semibold text-primary block mb-1">
                  About:
                </span>
                <p>{footerData?.about || "—"}</p>
              </div>

              <div>
                <span className="font-semibold text-primary block mb-1">
                  Copyright:
                </span>
                <p>{footerData?.copyright || "—"}</p>
              </div>
              <div>
                <span className="font-semibold text-primary block mb-1">
                  Action:
                </span>
                <EditOutlined
                  onClick={() => setIsEditing(true)}
                  className="cursor-pointer text-black text-[18px]"
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <div>
          <div className="bg-[#F9F9F9] p-4 sm:p-6 rounded-xl shadow-sm">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="About"
                name={["footer", "logo"]}
                rules={[{ required: true, message: "Please upload logo" }]}
              >
                <UploadImage listType="picture-card"/>
              </Form.Item>

              <Form.Item
                label="About"
                name={["footer", "about"]}
                rules={[{ required: true, message: "Enter about text" }]}
              >
                <TextArea rows={3} placeholder="About Company" />
              </Form.Item>

              <Form.Item
                label="Copyright"
                name={["footer", "copyright"]}
                rules={[{ required: true, message: "Enter copyright" }]}
              >
                <TextArea rows={2} placeholder="Enter Copyright" />
              </Form.Item>
            </Form>
          </div>

          <div className="flex gap-3 mt-7">
            <ButtonWrapper type="primary" onClick={handleSave} loading={loading}>
              Save
            </ButtonWrapper>
            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;
